import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.promise.finally";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import VueMask from 'v-mask';
import router from './router';
import { initFirebase } from '@/plugins/firebase';
import vuetify from '@/plugins/vuetify';
import './assets/js/filters';

// Plugins
import './plugins/axios';
import VueCookies from 'vue-cookies';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
var nomeApp = require('@/../package.json').name;
var versao = require('@/../package.json').version;
console.log("Vers\xE3o: ".concat(versao));
console.log("Ambiente: ".concat(process.env.NODE_ENV));
Vue.use(VueCookies);
Vue.use(VueMask);

// Css
import './assets/css/global.css';
Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'production') {
  try {
    console.debug('Iniciando o firebase');
    initFirebase();
  } catch (erro) {
    console.error('Não foi possível iniciar o Firebase.', erro);
  }
  console.debug('Configurando o Sentry');
  Sentry.init({
    dsn: 'https://3be878fabb8341459a3ad5228ab5f1a2@o92838.ingest.sentry.io/6552651',
    environment: window.location.host.indexOf('.melembre.com.br') !== -1 ? 'production' : 'staging',
    ignoreErrors: [
    // FirebaseError: Messaging: This browser doesn't support the API's required to use the Firebase SDK.
    'messaging/unsupported-browser'],
    integrations: [new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    })],
    logErrors: true,
    release: "".concat(nomeApp, "@").concat(versao),
    sendDefaultPii: true,
    tracesSampleRate: 0.05,
    Vue: Vue
  });
}
new Vue({
  router: router,
  store: store,
  vuetify: vuetify,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');
console.debug('Aplicação criada');
var moment = require("moment");
require("moment/locale/pt-br");
Vue.prototype.moment = moment;
Vue.use(require("vue-moment"), {
  moment: moment
});